












import traceQuery from '~/queries/trace.gql'

export default

	data: ->
		loaded: false
		sectionData: {}

	fetch: ->
		@sectionData = await @$craft.getEntry
			query: traceQuery
			variables:
				section: 'trace'
				type: 'breakdown'
				slug: 'breakdown'

		@loaded = true

	computed:

		blocks: -> @sectionData.breakdown.map (item) ->
			title: item.text
			copy: item.body

		accordionBlock: -> {
			layout: "full"
			textAlignment: "left"
			accordionPanes: @blocks
		}

